"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sendGtmWithRedirect = exports.sendDataLayerEvent = void 0;
function sendDataLayerEvent(eventName, data = {}) {
    try {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push(Object.assign({ event: eventName }, data));
    }
    catch (e) {
        console.error(`Can't send GA Event: ${e}`);
    }
}
exports.sendDataLayerEvent = sendDataLayerEvent;
function sendGtmWithRedirect(eventName, redirectUrl, data = {}) {
    sendDataLayerEvent(eventName, Object.assign(Object.assign({}, data), { 'eventCallback': function () { window.location.href = redirectUrl; } }));
}
exports.sendGtmWithRedirect = sendGtmWithRedirect;
